import { Popup } from "react-map-gl/mapbox";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
function FeaturePopup({
  feature,
  isOpen,
  onClose,
}: {
  feature: GeoJSON.Feature;
  isOpen: boolean;
  onClose: () => void;
}) {
  if (!isOpen) return null;
  if (!feature.properties || Object.keys(feature.properties).length === 0)
    return null;

  // Guard to ensure we have a geometry with coordinates
  const getCoordinates = (
    geometry: GeoJSON.Geometry,
  ): [number, number] | null => {
    if (geometry.type === "Point") {
      return geometry.coordinates as [number, number];
    }
    // For other geometry types, you might want to calculate centroid or handle differently
    return null;
  };

  const coordinates = getCoordinates(feature.geometry);
  if (!coordinates) return null;

  return (
    <Popup
      className="custom-popup"
      longitude={coordinates[0]}
      latitude={coordinates[1]}
      anchor="bottom"
      onClose={onClose}
    >
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Key</TableHead>
            <TableHead>Value</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {feature.properties &&
            Object.entries(feature.properties).map(([key, value]) => (
              <TableRow key={key}>
                <TableCell>
                  <strong>{key}</strong>
                </TableCell>
                <TableCell>{String(value)}</TableCell>
              </TableRow>
            ))}
        </TableBody>
      </Table>
    </Popup>
  );
}

export default function CustomPopups({
  data,
  openPopups,
  onClosePopup,
}: {
  data: GeoJSON.FeatureCollection;
  openPopups: Set<string | number>;
  onClosePopup: (featureId: string | number) => void;
}) {
  return (
    <>
      {data.features.map((feature) => (
        <FeaturePopup
          key={feature.id}
          feature={feature}
          isOpen={openPopups.has(feature.id!)}
          onClose={() => onClosePopup(feature.id!)}
        />
      ))}
    </>
  );
}
